module.exports = new __parcel__URL__("Here4TN_archive.47b022ef.png").toString();